import * as React from 'react';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { AdapterDateFnsJalali } from '@mui/x-date-pickers/AdapterDateFnsJalali';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import MuiTheme from './MuiTheme';
import { TextField } from '@mui/material';

function MuiDatePicker({ value, onChange, disabled = false, label }) {
  return (
    <LocalizationProvider dateAdapter={AdapterDateFnsJalali}>
      <MuiTheme>
        <DatePicker
          label={label}
          slotProps={{ textField: { size: "small" } }}
          value={value}
          onChange={onChange}
          className="w-full"
          style={{ fontSize: "0.75rem" }}
        />
      </MuiTheme>
    </LocalizationProvider>
  );
}

export default MuiDatePicker;
